import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PreviewAddressComponent } from '../../../../shared/components/address/preview-address/preview-address.component';
import { Card } from 'primeng/card';
import { Beneficjent } from '../../../../shared/models/beneficjent';
import { PreviewDataWrapperComponent } from '../../../../shared/components/preview-data-wrapper/preview-data-wrapper.component';
import { PreviewDataType } from '../../../../shared/enums/preview-data-type.enum';

@Component({
  selector: 'app-preview-beneficiary-address',
  imports: [PreviewAddressComponent, Card, PreviewDataWrapperComponent],
  templateUrl: './preview-beneficiary-address.component.html',
  styleUrl: './preview-beneficiary-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewBeneficiaryAddressComponent {
  public beneficiary = input<Beneficjent>();
  protected readonly PreviewDataType = PreviewDataType;
}
